import OfferOrderTable from './_table.js'
import template from './index.pug'

import {generateMonthStructureForOfferOrder} from '../demand-table/helpers'

export default Vue.extend({
  template: template(),
  components: {
    OfferOrderTable
  },
  props: {
    demandData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      orders: [],
      monthsUsed: {},
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('leadtrade.offerOrder.index.title'))
    this.$setBreadcrumbs([
      {
        label: this.$t('breadcrumbs.offer-and-demand.index'),
        route: {name: 'offer-and-demand-index'}
      },
      {label: this.$t('breadcrumbs.offer-order.index'), route: {}}
    ])
  },
  methods: {
    loadOrders(queryOptions = {}) {
      this.orders = []
      this.monthsUsed = {}
      this.meta = {}
      API.offerPurchase.order.index(queryOptions).then(({data, meta}) => {
        const {orders, monthsUsed} = generateMonthStructureForOfferOrder(data)
        this.orders = orders
        this.monthsUsed = monthsUsed
        this.meta = meta
      })
    }
  }
})
